import { atom } from "recoil";

export const playerBanStore = atom({
	key: "playerBanStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			status: false,
		},
		currentSearch: "",
		currentSearchType: { value: "id", label: "id" },
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: true,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
